
// Core modules
import { Component, Input, Output, EventEmitter, SimpleChanges, OnInit, OnChanges } from '@angular/core';

import _keys from 'lodash-es/keys';
import _drop from 'lodash-es/drop';
import _toNumber from 'lodash-es/toNumber';
import _split from 'lodash-es/split';
import _join from 'lodash-es/join';
import _cloneDeep from 'lodash-es/cloneDeep';

import { Yii } from "libraries/interfaces/Yii";
import { WORDING } from "./config/wording";
import { ILabels } from "libraries/interfaces/ILabels";
import { LanguageService } from "libraries/service/language/language.service";
import { faEye, IconDefinition, faEyeSlash, faPlus, faMinus, faCheck, faTimes, faPen } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'ssr',
    templateUrl: './ssr.component.html',
    styleUrls: ['./ssr.component.scss']
})
export class SSRComponent implements OnInit, OnChanges{
    public wording: ILabels = WORDING;
    @Input()
    public ssrList: any;

    @Input()
    public traveller: any;

    @Input()
    public travellerName: any;
    @Input()
    public showSSR: boolean = false;

    @Input()
    public ssrImport: any = {};

    @Output()
    public SSRSelected: EventEmitter<any> = new EventEmitter();

    @Input()
    public SSRAdded: string[] = [];


    public Yii = Yii;
    public SSRAddedAll: string[] = [];
    public language: string = 'fr';
    public mealVisible: boolean = false;
    public speqVisible: boolean = false;
    public openedForm: any = null;
    public colwidth: number; //form width
    public formValues: any = {};//Container for datas from forms formValues.travellerkey.ssrkey

    public iconEye: IconDefinition = faEye;

    public iconEyeSlash: IconDefinition = faEyeSlash;

    public iconPen: IconDefinition = faPen;

    public iconPlus: IconDefinition = faPlus;

    public iconMinus: IconDefinition = faMinus;

    public iconCheck: IconDefinition = faCheck;

    public iconTimes: IconDefinition = faTimes;

    constructor(
        private readonly languageService: LanguageService,
    ) {
    }
    public ngOnInit(): void {
        this.language  = this.languageService.getUserLanguage();
        this.setColwidth();
    }
    public ngOnChanges(_changes: SimpleChanges): void {
        if (_changes.showSSR) {
            this.mealVisible = _changes.showSSR.currentValue;
            this.speqVisible = _changes.showSSR.currentValue;
        }
    }

    public setColwidth(): void {
        this.colwidth = (_keys(this.traveller)).length + 2;//number of col for colspan
    }

    public getColwidth(): number {
        return (_keys(this.traveller)).length + 2;//number of col for colspan
    }

    /**
     * addSSR
     * add SSR for a traveller / all sectors
     * @travellerItem : select traveller
     * @ssrkey: ssr code
     * @key : ssr family (meal/luggage)
     */
    public addSSR(travellerItem: string, ssrkey: string, key: string): void {
        //If meal, then test if already a meal selected, and if yes, remove it

        let textValue: string;
        if (key === "meal") {

            for (const ssrkeyMeal of Object.keys(this.ssrList.meal)) {
                this.removeSSR(travellerItem, ssrkeyMeal);
            }
        }

        if (key === "luggage") {
            //if not opened yet, create it
            for (const ssrkeyLug of Object.keys(this.ssrList.luggage)) {
                this.removeSSR(travellerItem, ssrkeyLug);
            }
            if (!this.formValues[travellerItem]) {

                this.formValues[travellerItem] = {};
            }

            if (!this.formValues[travellerItem][ssrkey]) {

                this.formValues[travellerItem][ssrkey] = {};

                for (const fieldkey of Object.keys(this.ssrList[key][ssrkey].text.field)) {
                    this.formValues[travellerItem][ssrkey][fieldkey] =
                        this.ssrList[key][ssrkey].text.field[fieldkey].default.value;
                }
            }
            textValue = this.formValues[travellerItem][ssrkey];

        }

        if (!this.SSRAdded[travellerItem + ssrkey]) {
            this.SSRAdded.push(travellerItem + ssrkey);
        }
        this.SSRAdded[travellerItem + ssrkey] = true;

        const action: string = "select";
        this.send({travellerItem, ssrkey, action, textValue});

    }


    /**
     * removeSSR
     * remove SSR for a traveller / all sectors
     * @travellerItem : select traveller
     * @ssrkey: ssr code
     * @key : ssr family (meal/luggage)
     */
    public removeSSR(travellerItem: string, ssrkey: string): void {

        const index: number = this.SSRAdded.indexOf(travellerItem + ssrkey);
        this.SSRAdded[travellerItem + ssrkey] = false;
        this.SSRAdded.splice(index, 1);

        const action: string = "unselect";
        this.send({travellerItem, ssrkey, action});

        //uncheck "All" checkbox for this ssrkey
        this.SSRAddedAll[ssrkey] = false;

        //closeForm if opened
        this.closeForm();

        //remove Values from formValues(luggage)
        if (this.formValues[travellerItem] && this.formValues[travellerItem][ssrkey]) {
            delete this.formValues[travellerItem][ssrkey];
            if (Object.keys(this.formValues[travellerItem]).length === 0) {
                delete this.formValues[travellerItem];
            }
        }
    }

    /**
     * addSSRAll
     * remove SSR for all traveller / all sectors
     * @ssrkey: ssr code
     * @key : ssr family (meal/luggage)
     */
    public addSSRAll(ssrkey: string, key: string): void {
        for (const traveller of _keys(this.traveller)) {
            this.addSSR(traveller, ssrkey, key);
        }
        this.SSRAddedAll[ssrkey] = true;
    }


    /**
     * removeSSRAll
     * remove SSR for all traveller / all sectors
     * @ssrkey: ssr code
     * @key : ssr family (meal/luggage)
     */
    public removeSSRAll(ssrkey: string): void {
        for (const traveller of _keys(this.traveller)) {
            this.removeSSR(traveller, ssrkey);
        }
        this.SSRAddedAll[ssrkey] = false;
    }

    /**
     * openForm
     * open selected form, and close the other
     */
    public openForm(travellerItem: any, key: string, ssrkey: string): void {
        this.openedForm = {
            travellerItem,
            ssrkey,
            key,
            propertyId: travellerItem + ssrkey
        };
    }


    /**
     * closeForm
     * close selected
     */
    public closeForm(): void {
        if (this.openedForm) {
            this.updateForm(this.openedForm.travellerItem, this.openedForm.ssrkey);
            this.openedForm = null;
        }
    }

    /**
     * updateForm
     * launched on input blur
     */
    public updateForm(travellerItem: string, ssrkey: string): void {
        const action: string = "update";
        const textValue: string = this.textIntegrity(this.formValues[travellerItem][ssrkey]);
        this.send({travellerItem, ssrkey, action, textValue});
    }

    /**
     * textIntegrity
     * weight... in number
     */
    public textIntegrity(textValue: any): any {
        const output = _cloneDeep(textValue);

        for (const key of Object.keys(textValue)) {
            if (key !== "comment") {
                output[key] = _toNumber(output[key]);
            }

        }

        return output;
    }

    public send = (inValues: any) => {
        this.SSRSelected.next(inValues);
    }

    public removeStart(_string: string): string {
        let output: string = _string;

        let array = _split(_string, " ");
        if (array[0] === 'Repas') {
            array = _drop(array);
            output = _join(array, " ");
        }
        return output;
    }

    public isImported(_travellerKey: string, _ssrKey: string, _ssrTypeKey: string): boolean {
        let output: boolean = false;

        if (this.ssrImport &&
            this.ssrImport[_travellerKey] &&
            this.ssrImport[_travellerKey][_ssrTypeKey] &&
            this.ssrImport[_travellerKey][_ssrTypeKey][_ssrKey]) {
            output = true;
        }

        return output;
    }




    /**
     * number function to be removed once a proper form will be done
     */


    /**
     * Add 1 or this.step to field value,
     * except if the result is > this.max
     */
    public increase(_idTraveller, _idSsr, _fieldkey): void {
        const input = document.getElementsByClassName(_fieldkey)[0] as HTMLInputElement;
        let value: any = input.value;
        value++;
        input.value = value;
        this.formValues[_idTraveller][_idSsr][_fieldkey] = value;
    }


    /**
     * Subtract 1 or this.step to field value,
     * except if the result is < this.min
     */
    public decrease(_idTraveller, _idSsr, _fieldkey): void {
        const input = document.getElementsByClassName(_fieldkey)[0] as HTMLInputElement;

        let value: any = input.value;

        if (value > input.min) {
            value--;
        }
        input.value = value;
        this.formValues[_idTraveller][_idSsr][_fieldkey] = value;
    }


    /**
     * onlyNumberKey
     *
     * force number charCode
     * https://stackoverflow.com/questions/37435529/angular2-proper-way-to-restrict-text-input-values-e-g-only-numbers
     * 48 to 53 : numbers
     * 13= Enter
     */
    public onlyNumberKey(_event: any): boolean {
        return (_event.charCode === 8 || _event.charCode === 0) ?
            false :
            ((_event.charCode >= 48 && _event.charCode <= 57) || _event.charCode === 13);
    }


}
